import { useState } from "react";
import { ChevronRight, ChevronDown } from "lucide-react";
import type { ReasoningTraceBlock } from "@netsuite-ai/types";

interface Props {
  block: ReasoningTraceBlock;
}

export function ReasoningTrace({ block }: Props) {
  const [collapsed, setCollapsed] = useState(true);

  return (
    <div className="my-2 overflow-hidden rounded border border-neutral-200 bg-white shadow-sm">
      <button
        onClick={() => setCollapsed((v) => !v)}
        className="flex w-full items-center gap-2 px-4 py-3 text-left text-sm font-medium text-neutral-700 hover:bg-neutral-50"
      >
        {collapsed ? <ChevronRight size={16} /> : <ChevronDown size={16} />}
        {collapsed ? "Show steps" : "Hide steps"}
      </button>

      {!collapsed && (
        <div className="bg-code px-4 py-3 space-y-2">
          {block.steps.map((step, i) => (
            <div key={i} className="flex flex-wrap items-center gap-2 text-xs">
              {step.skillFired && (
                <span className="text-code-bright">{step.skillFired}</span>
              )}
              {step.toolCalled && (
                <span className="text-cyan-400">{step.toolCalled}</span>
              )}
              {step.recordIds?.map((id) => (
                <span key={id} className="text-green-400">
                  {id}
                </span>
              ))}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
